// hooks/useArticles.js - VERSIONE AXIOS
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useArticles = (theme = null) => {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const source = axios.CancelToken.source();
        
        const fetchArticles = async () => {
            try {
                setLoading(true);
                setError(null);
                
                let url = '/api/articles';
                if (theme) {
                    url = `/api/articles/theme/${theme}`;
                }
                
                //console.log('📚 Fetching articles from:', url);
                
                const response = await axios.get(url, {
                    cancelToken: source.token
                });
                
                //console.log('✅ Articles response:', response.data.success ? `${response.data.data?.length || 0} articles` : 'Failed');
                
                if (response.data.success && Array.isArray(response.data.data)) {
                    setArticles(response.data.data);
                } else {
                    setArticles([]);
                    if (response.data.message) {
                        console.warn('⚠️ No articles data:', response.data.message);
                    }
                }
                
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error('❌ Error fetching articles:', err.message);
                    setError(err.message);
                    setArticles([]);
                }
            } finally {
                setLoading(false);
            }
        };
        
        fetchArticles();
        
        return () => source.cancel('Component unmounted');
    }, [theme]);
    
    return { 
        articles, 
        loading, 
        error 
    };
};
